export const formatDate = (date) => {
  const formattedDate = date
    .toLocaleString("sv-SE", { timeZone: "UTC" })
    .replace("T", " ");
  return formattedDate;
};

export const compareDates = (dateString) => {
  const inputDate = new Date(dateString);
  const currentDate = new Date();

  if (inputDate.getTime() < currentDate.getTime()) {
    return -1;
  } else if (inputDate.getTime() > currentDate.getTime()) {
    return 1;
  } else {
    return 0;
  }
};

export const cCode_to_nation = (cCode) => {
  if (cCode === "kr") return "한국";
  else if (cCode === "cn") return "중국";
  else if (cCode === "us") return "미국";
  else if (cCode === "jp") return "일본";
  else if (cCode === "in") return "인도";
  else if (cCode === "sg") return "싱가포르";
  else if (cCode === "tw") return "대만";
  else return null;
};

export const nation_to_cCode = (nation) => {
  if (nation === "한국" || nation === "대한민국") return "kr";
  else if (nation === "중국") return "cn";
  else if (nation === "미국") return "us";
  else if (nation === "일본") return "jp";
  else if (nation === "인도") return "in";
  else if (nation === "싱가포르") return "sg";
  else if (nation === "대만") return "tw";
  else return null;
};
